import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AdjustOutlinedIcon from '@mui/icons-material/AdjustOutlined';
import { StepConnector, stepConnectorClasses, styled, Tooltip } from '@mui/material';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.border.brandPrimary,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.border.brandPrimary,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: '#CFD6DC',
        borderTopWidth: 2,
        borderRadius: 1,
        // ...theme.applyStyles('dark', {
        //   borderColor: theme.palette.grey[800],
        // }),
    },
}));

const QontoStepIconRoot = styled('div')(({ theme }) => ({
    color: '#CFD6DC',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    // '& .QontoStepIcon-completedIcon': {
    //     color: theme.palette.brandPrimary[500],
    // },
    // '& .QontoStepIcon-circle': {
    //     backgroundColor: 'currentColor',
    // },
    // ...theme.applyStyles('dark', {
    //     color: theme.palette.grey[700],
    // }),
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                color: theme.palette.brandPrimary[500],
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                color: theme.palette.brandPrimary[500],
            },
        },
    ],
}));

function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active, completed }} className={className}>
            {completed ? <CheckCircleIcon /> : active ? <AdjustOutlinedIcon /> : <CircleOutlinedIcon />}
        </QontoStepIconRoot>
    );
}

export default function Steps({ currentStep, totalScreens = [], currentScreenData, mode }) {
    // const steps = totalSteps ? Array.from({ length: totalSteps }).map((_, index) => `${index}`) : [];
    const allSteps = totalScreens?.length > 0 ? [...totalScreens] : [];

    let activeStep = totalScreens?.findIndex((c) => c?.Id === currentScreenData?.Id);

    activeStep = activeStep === -1 && currentStep > activeStep ? currentStep : activeStep;

    return (
        <Box
            width={{
                md: mode === 'public' ? '100%' : '600px',
                xs: 'calc(100% + 16px)',
            }}
            marginTop={{
                md: 0,
                xs: '16px',
            }}
            marginLeft={{
                md: 0,
                xs: '-8px',
            }}
            marginRight={{
                md: 0,
                xs: '-8px',
            }}
            display={{
                xs: 'none',
                md: 'block',
            }}
        >
            <Stepper
                activeStep={activeStep}
                connector={<QontoConnector />}
                sx={(theme) => ({
                    '& .MuiStepLabel-iconContainer': {
                        paddingRight: '0',
                    },
                })}
            >
                {allSteps.map((step) => (
                    <Step key={step?.Id}>
                        <Tooltip title={step?.Name || ''} arrow placement="bottom">
                            <StepLabel StepIconComponent={QontoStepIcon}></StepLabel>
                        </Tooltip>
                    </Step>
                ))}
            </Stepper>
        </Box>
    );
}
